import { type FC } from "react";
import { type ProductData } from "~/domains/product/types/ProductData";
import ProductDesignation from "~/features/productDetails/components/ProductDesignation";
import { ParamComponent } from "~/common/components/ParamsGrid";
import { Stack } from "~/common/mui";
import ProductMMD from "~/domains/product/components/ProductMMD";

import * as WeightUtils from "~/utils/WeightUtils";
import { type WeightData } from "~/domains/product/types/WeightData";
import { getAliases } from "~/domains/product/components/ProductAliases";
import { Translation } from "~/app/i18n/Translation";
import { useTranslation } from "react-i18next";
import { useProductDetailsUrl } from "~/features/PackageRestriction/hooks/useProductDetailsUrl";

interface OrderTableProductProps {
  product: ProductData;
  weight?: WeightData;
}

const OrderTableProduct: FC<OrderTableProductProps> = ({ product, weight }) => {
  const { t } = useTranslation();

  const url = useProductDetailsUrl(product);
  let designation = (
    <ProductDesignation isPreferred={product.preferred} designation={product.designation} size={"title-medium"} />
  );
  if (url) {
    designation = <a href={url}>{designation}</a>;
  }
  return (
    <div className="scha__order-table__product">
      <Stack gap={1}>
        {designation}
        {product.marketDesignation && <ProductMMD marketDesignation={product.marketDesignation} />}
      </Stack>
      {product.shortDescription && (
        <div className="scha__order-table__product__description">
          <Translation {...product.shortDescription} />
        </div>
      )}
      {product.sapMaterialNumber && (
        <ParamComponent label={t("cartPage.table.header.schaId.title")} value={product.sapMaterialNumber} />
      )}
      {getAliases(product, "13-digits").length > 0 && (
        <ParamComponent label={t("product.customerId")} value={getAliases(product, "13-digits").join(", ")} />
      )}
      {weight && <ParamComponent label={t("quoteDetailsPage.table.weight")} value={WeightUtils.text(weight)} />}
    </div>
  );
};

export default OrderTableProduct;
